var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 407,
    height: 245,
    viewBox: "0 0 407 245",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2425_595)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2425_595",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 406,
    height: 244
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M407 0H1V244H407V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2425_595)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225 22.1C181.3 36.1 43 -32.9 53.8 61.4C55.5 75.4 64.5 95.2 56.9 108.3C51.4 118.1 41.3 123.8 31.6 127.7C6.10002 138.1 -3.29998 157.6 3.10002 185.4C20.3 260.4 114.2 242.6 163.5 220.4C198.5 203.9 239.9 201 276.2 215C304.6 226.4 322.3 250.3 355.7 243.3C385.3 237.3 389.8 209.3 381.1 183.2C376.2 167 372.7 160.2 382.4 144.6C390.6 129.1 405 117.4 406.2 99.2C406.4 79.5 397.5 59.7 380 52.3C365.8 46.2 352.9 48.7 338.8 44.9C307.5 36.1 287.3 -12.8 248.5 3.99996C238.8 8.59996 233.4 19.2 222.8 22.3",
    fill: "#2F32FE",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.4 133.2C151.6 133.2 154.7 130.4 154.5 127C154.4 123.7 151.8 120.8 148.4 120.8C145 120.8 142.1 123.6 142.3 127C142.3 130.3 145 133.2 148.4 133.2Z",
    fill: "#EAEAFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.9 133.2C262.1 133.2 265.2 130.4 265 127C264.9 123.7 262.3 120.8 258.9 120.8C255.5 120.8 252.6 123.6 252.8 127C252.8 130.3 255.5 133.2 258.9 133.2Z",
    fill: "#EAEAFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.6 220H113.4C111.8 220 105.3 219.8 99.0002 219.1C95.3002 218.8 92.5002 218.3 90.4002 217.8C89.3002 217.5 88.3002 217.2 87.6002 216.9C87.4002 216.8 87.3002 216.7 87.2002 216.7C87.0002 216.7 86.9002 216.5 86.8002 216.4H86.7002V215.7L108.5 183.1V182.7C108.5 179.4 110.6 176.8 113.2 176.8H293.6C296.2 176.8 298.3 179.4 298.3 182.7C299.4 184.4 312.9 204.9 320.1 215.7L320.3 216L319.9 216.4C319.8 216.5 319.5 216.8 319.1 216.9C318.5 217.2 317.6 217.5 316.4 217.8C313.7 218.4 310.7 218.8 307.8 219.1C301.6 219.7 294.9 220 293.5 220H293.6ZM87.9002 215.8C87.9002 215.8 88.0002 215.8 88.1002 216C88.7002 216.2 89.6002 216.5 90.7002 216.8C92.7002 217.3 95.4002 217.7 99.1002 218.1C105.8 218.8 112.4 219 113.4 219H293.6C295 219 301.7 218.7 307.9 218.1C310.7 217.8 313.7 217.4 316.3 216.8C317.4 216.5 318.3 216.2 318.9 215.9C319 215.9 319.1 215.9 319.2 215.8C304.734 193.933 297.5 182.933 297.5 182.8V182.6C297.5 179.9 295.8 177.7 293.8 177.7H113.3C111.3 177.7 109.6 179.9 109.6 182.6L109.8 182.9L87.9002 215.8Z",
    fill: "#EAEAFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.5 208.3H120.1L128.2 188.6H170.1L166.4 208.3H166.5Z",
    fill: "#EAEAFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.7 208.3H287.1L279 188.6H237.1L240.8 208.3H240.7Z",
    fill: "#EAEAFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.3 208.3H308.6L295.2 188.6H282.9L292.3 208.3Z",
    fill: "#EAEAFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115 208.3H98.7002L112.1 188.6H124.4L115.1 208.3H115Z",
    fill: "#EAEAFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.7 208.3H170.7L174.4 188.6H233.1L236.8 208.3H236.7Z",
    fill: "#EAEAFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.6 58.6999C206.1 58.6999 206.1 54.7999 203.6 54.7999C201.1 54.7999 201.1 58.6999 203.6 58.6999Z",
    fill: "#EAEAFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.4 119.9C165 119.9 164.6 119.7 164.2 119.4C163.6 118.8 163.6 117.7 164.2 117.1L178.1 103.2C178.7 102.6 179.8 102.6 180.4 103.2C181 103.8 181 104.9 180.4 105.5L166.5 119.4C166.2 119.7 165.8 119.9 165.3 119.9H165.4Z",
    fill: "#EAEAFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.3 120C178.9 120 178.5 119.8 178.1 119.5L164.2 105.6C163.6 105 163.6 103.9 164.2 103.3C164.8 102.7 165.9 102.7 166.5 103.3L180.4 117.2C181 117.8 181 118.9 180.4 119.5C180.1 119.8 179.7 120 179.2 120H179.3Z",
    fill: "#EAEAFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228 119.9C227.6 119.9 227.2 119.7 226.8 119.4C226.2 118.8 226.2 117.7 226.8 117.1L240.7 103.2C241.3 102.6 242.4 102.6 243 103.2C243.6 103.8 243.6 104.9 243 105.5L229.1 119.4C228.8 119.7 228.4 119.9 227.9 119.9H228Z",
    fill: "#EAEAFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.9 120C241.5 120 241.1 119.8 240.7 119.5L226.8 105.6C226.2 105 226.2 103.9 226.8 103.3C227.4 102.7 228.5 102.7 229.1 103.3L243 117.2C243.6 117.8 243.6 118.9 243 119.5C242.7 119.8 242.3 120 241.8 120H241.9Z",
    fill: "#EAEAFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.3 144.7C178.9 144.7 178.5 144.6 178.2 144.3C177.5 143.7 177.5 142.6 178.2 142C180.6 139.4 189.6 130.9 203.7 130.9H203.9C217.7 130.9 226.7 139.4 229.1 142C229.7 142.7 229.7 143.7 229.1 144.3C228.4 144.9 227.4 144.9 226.8 144.3C224.6 142 216.5 134.3 204 134.2C204 134.2 203.9 134.2 203.8 134.2C191.1 134.2 182.9 141.9 180.7 144.3C180.4 144.6 179.9 144.8 179.5 144.8L179.3 144.7Z",
    fill: "#EAEAFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.7 228.1H88.6C87.9 228.1 87.4 228 87 227.7C86.6 227.5 86.3 227.1 86.1 226.8C85.7 226.1 85.5 225.1 85.5 223.4V219.3C85.5 217.6 85.7 216.6 86.1 216C86.3 215.5 86.6 215.2 87.1 215C87.4 214.8 88 214.6 88.6 214.6H318.6C319.3 214.6 319.8 214.7 320.2 215C320.6 215.2 320.9 215.6 321.1 215.9C321.5 216.6 321.7 217.6 321.7 219.3V223.4C321.7 225.1 321.7 226.1 321.2 226.7C321 227.2 320.7 227.5 320.2 227.7C319.9 227.9 319.3 228.1 318.7 228.1ZM88.6 215.6C88.2 215.6 87.8 215.6 87.6 215.8C87.2 216 87.1 216.1 87 216.4C86.6 217.1 86.6 218.3 86.6 219.3V223.4C86.6 224.4 86.6 225.6 87 226.3C87.1 226.5 87.4 226.8 87.6 226.9C87.8 227 88.1 227.1 88.6 227.1H318.7C319.1 227.1 319.5 227.1 319.7 226.9C320.1 226.7 320.2 226.6 320.3 226.3C320.6 225.7 320.7 224.8 320.7 223.9V219.3C320.7 218.3 320.7 217.1 320.3 216.4C320.2 216.2 319.9 215.9 319.7 215.8C319.5 215.7 319.2 215.6 318.7 215.6H88.6Z",
    fill: "#EAEAFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.2 224H162.9C161.5 224 160.4 222.9 160.4 221.5C160.4 220.1 161.5 219 162.9 219H244.2C245.6 219 246.7 220.1 246.7 221.5C246.7 222.9 245.6 224 244.2 224ZM162.9 220C162.1 220 161.4 220.7 161.4 221.5C161.4 222.3 162.1 223 162.9 223H244.2C245 223 245.7 222.3 245.7 221.5C245.7 220.7 245 220 244.2 220H162.9Z",
    fill: "#EAEAFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.2 182.8H111.1C108.5 182.8 106.4 180.7 106.4 178.1V56.9C106.4 54.3 108.5 52.2 111.1 52.2H296.2C298.8 52.2 300.9 54.3 300.9 56.9V178.1C300.9 180.7 298.8 182.8 296.2 182.8ZM111.1 53.2C109.1 53.2 107.4 54.9 107.4 56.9V178.1C107.4 180.1 109.1 181.8 111.1 181.8H296.2C298.2 181.8 299.9 180.1 299.9 178.1V56.9C299.9 54.9 298.2 53.2 296.2 53.2H111.1Z",
    fill: "#EAEAFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.3 36V76.7C269.3 80.7 275.4 80.7 275.4 76.7V36C275.4 32 269.3 32 269.3 36Z",
    fill: "#EEB728"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.4 92.4C274.8 92.4 277.1 90.3 277 87.8C276.9 85.3 275 83.2 272.4 83.2C269.8 83.2 267.7 85.3 267.8 87.8C267.9 90.3 269.8 92.4 272.4 92.4Z",
    fill: "#EEB728"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2425_595"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 406,
    height: 244,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorDark);
export default __webpack_public_path__ + "static/media/error-dark.45509049.svg";
export { ForwardRef as ReactComponent };